import { useApi } from '@mainstage/core-plugin-api';
import { createContext, FC, ReactNode, useContext } from 'react';
import { WbSafeNunjucksApi, wbSafeNunjucksApiRef } from '../../../apis';

export type CustomViewNunjucksRenderer = WbSafeNunjucksApi;

type CustomViewNunjucksRendererContextType = CustomViewNunjucksRenderer;

const defaultCustomViewNunjucksRendererContext = null;

export const CustomViewNunjucksRendererContext =
  createContext<CustomViewNunjucksRendererContextType | null>(
    defaultCustomViewNunjucksRendererContext,
  );

export const useCustomViewNunjucksRenderer = () => {
  const contextValue = useContext(CustomViewNunjucksRendererContext);

  if (!contextValue) {
    throw new Error(
      'useCustomViewNunjucksRenderer has to be used within <CustomViewNunjucksRendererContext.Provider>',
    );
  }

  return contextValue;
};

export const CustomViewNunjucksRendererProvider: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const nunjucksApi = useApi(wbSafeNunjucksApiRef);

  return (
    <CustomViewNunjucksRendererContext.Provider value={nunjucksApi}>
      {children}
    </CustomViewNunjucksRendererContext.Provider>
  );
};
